import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Quanto tempo tenho para reclamar meus direitos trabalhistas?',
      answer: 'O prazo prescricional para ações trabalhistas é de 2 anos após o término do contrato de trabalho, sendo possível reclamar direitos referentes aos últimos 5 anos de trabalho. É importante buscar orientação jurídica o quanto antes para não perder seus direitos.'
    },
    {
      question: 'Preciso ter sido demitido para buscar meus direitos?',
      answer: 'Não necessariamente. Você pode buscar orientação jurídica mesmo estando empregado, especialmente em casos de irregularidades graves como assédio moral, condições insalubres não reconhecidas, ou não pagamento de horas extras. Cada situação deve ser analisada individualmente.'
    },
    {
      question: 'Como funciona o pagamento dos honorários advocatícios?',
      answer: 'Os honorários advocatícios são definidos de acordo com a complexidade do caso, o trabalho envolvido e outros fatores. Essa conversa acontece de forma transparente durante a consulta inicial, respeitando sempre as normas éticas da OAB. Entre em contato para discutirmos seu caso específico.'
    },
    {
      question: 'Quanto tempo dura um processo trabalhista?',
      answer: 'O tempo de duração varia conforme a complexidade do caso, a comarca, a necessidade de perícias e outros fatores. Processos mais simples podem ser resolvidos em alguns meses, enquanto casos complexos podem levar mais tempo. Durante todo o processo, você será mantido informado sobre o andamento.'
    },
    {
      question: 'Posso ter certeza de que vou ganhar a causa?',
      answer: 'Não é ético nem possível garantir o resultado de qualquer ação judicial. O que posso oferecer é uma análise técnica honesta do seu caso, orientação sobre as possibilidades jurídicas e dedicação integral na defesa dos seus direitos. Cada caso é avaliado com base nas provas e na legislação aplicável.'
    },
    {
      question: 'Preciso ter documentos para iniciar uma consulta?',
      answer: 'Documentos como carteira de trabalho, contracheques, rescisão, comprovantes de pagamento e mensagens relacionadas ao trabalho são muito úteis, mas não são obrigatórios para a primeira conversa. Durante a consulta inicial, orientarei sobre quais documentos serão necessários para o seu caso específico.'
    },
    {
      question: 'O que é considerado assédio moral no trabalho?',
      answer: 'Assédio moral caracteriza-se por condutas abusivas, repetitivas e prolongadas que atingem a dignidade ou integridade psíquica do trabalhador, colocando em risco seu emprego ou degradando o ambiente de trabalho. Exemplos incluem humilhações públicas, isolamento, sobrecarga proposital de tarefas, entre outros.'
    },
    {
      question: 'Posso ser demitido durante o período de estabilidade?',
      answer: 'Existem situações que garantem estabilidade provisória ao trabalhador, como gravidez, acidente de trabalho, membro da CIPA, entre outras. A demissão durante esses períodos pode ser considerada nula ou gerar direito a indenização. Cada caso deve ser analisado conforme suas particularidades.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#4A1C40] mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Dúvidas Frequentes
          </h2>
          <p className="text-lg text-gray-700" style={{ fontFamily: 'Inter, sans-serif' }}>
            Respostas para as perguntas mais comuns sobre direitos trabalhistas e atuação jurídica.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-[#4A1C40] pr-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
                  {faq.question}
                </h3>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-2xl text-[#C9A961] flex-shrink-0`}></i>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-800 leading-relaxed text-base" style={{ fontFamily: 'Inter, sans-serif' }}>
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#4A1C40] to-[#5A2C50] rounded-2xl p-10 text-center">
          <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Ainda tem dúvidas?
          </h3>
          <p className="text-gray-100 mb-6 text-base leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            Entre em contato para esclarecer suas questões específicas. Cada caso merece atenção individualizada.
          </p>
          <a 
            href="https://wa.me/5532998566774?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#C9A961] text-[#4A1C40] rounded-lg font-semibold hover:bg-[#D9B971] transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}